<template>
  <el-dialog
    title="出库详情"
    :visible.sync="visible"
    width="900px"
    @close="$emit('update:show', false)"
  >
    <el-table :data="item.item_out_record_lists">
      <el-table-column
        label="供应方"
        prop="item_in_record.supplier"
      ></el-table-column>
      <el-table-column
        label="出货批次"
        prop="item_in_record.arrive_batch"
      ></el-table-column>
      <el-table-column label="数量" prop="number"></el-table-column>
      <el-table-column label="出库时间">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { itemOutRecordDetail } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (this.visible) {
        if (this.model.id) {
          this.getItemInfo(this.model.id)
        }
      }
    },
  },
  data() {
    return {
      item: {},
      visible: this.show,
    }
  },
  methods: {
    async getItemInfo(id) {
      let res = await itemOutRecordDetail(id)
      if (res.status == 0) {
        this.item = res.data
      }
    },
  },
}
</script>